import React, { createContext, useState } from 'react'

interface IChargePointContext {
    autoRefresh: boolean
    toggleAutoRefresh: () => void
    setAutoRefresh: (isEnabled: boolean) => void
}

const defaultState: IChargePointContext = {
    autoRefresh: false,
    toggleAutoRefresh: () => {},
    setAutoRefresh: () => {},
}

const ChargePointContext = createContext<IChargePointContext>(defaultState)

interface IChargePointProvider {
    children: React.ReactNode
}

const ChargePointContextProvider = ({ children }: IChargePointProvider) => {
    const [autoRefresh, setAutoRefresh] = useState<boolean>(true)

    const toggleAutoRefresh = () => {
        setAutoRefresh(!autoRefresh)
    }

    return (
        <ChargePointContext.Provider value={{ autoRefresh, toggleAutoRefresh, setAutoRefresh }}>
            {children}
        </ChargePointContext.Provider>
    )
}

const useChargePointContext = () => {
    const context = React.useContext(ChargePointContext)

    if (!context) {
        throw new Error('useChargePointContext must be used within a ChargePointProvider')
    }

    return context
}

export { ChargePointContext, ChargePointContextProvider, useChargePointContext }
